module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAARBJREFUOE+N0rsuxGEQxuFnNg7RqIlEFCIhQUNFxw1o6LkTdyERvUhcgdI2Eg0JkSgoHHqFOO3I999dxGHttO/7/WbmmzeybgvT0pAwjH6EzpV4ku6Ee5xG1t1K23gQFqQZYQS9vwAL4EW6EU6kujCIjQJ6wYW0i2NhUloWpqgm7GkN94o76Uw4kM4xhzVhooBKl1LPVF12hXNpVljCeEu/bAGKpzQpgGn0Ff0rqOlPT8IR9jRcqVWPaDhTM4ZVaV5Uf/lRP0Gf2qN0iH1Rff4KFjHw2x06gdr+9uodL9kN6J8kNOUCemud+b/s/AUsEzcK6AKjXQbxO6wZTK4jD20K61WqU62rPdqm0KjSnXbeAbryX0KpQ/2nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mail.png
// module id = d/FW
// module chunks = 26